import { object, string, date, number, array } from "yup";
import { FormSchema, SectionDefinition, ValidationDefinition } from "api/factories/form.factory";
import { useMemo } from "react";
import { SectionDefinitionValue } from "components/SchemaProvider";
import { parse, isDate } from "date-fns";
import { getLocaleDateTimeFormat } from "utils";

export const useLazySchema = (schema: FormSchema[]) => {
    return useMemo(() => {
        const parseDateString = (value: Date, originalValue: string) => {
            return isDate(originalValue) ? originalValue : parse(originalValue, getLocaleDateTimeFormat(), new Date());
        };

        const createDateValidator = (validations: ValidationDefinition[]) => {
            return validations.reduce((validator, { type, params }) => {
                // TODO: Find a way how to type properly StringSchema
                // @ts-ignore
                return validator[type](...params);
            }, date().nullable().transform(parseDateString));
        };

        const createStringValidator = (validations: ValidationDefinition[]) => {
            return validations.reduce((validator, { type, params }) => {
                // TODO: Find a way how to type properly StringSchema
                // @ts-ignore
                return validator[type](...params);
            }, string());
        };

        const createNumberValidator = (validations: ValidationDefinition[]) => {
            return validations.reduce((validator, { type, params }) => {
                // TODO: Find a way how to type properly StringSchema
                // @ts-ignore
                return validator[type](...params);
            }, number());
        };

        const createStringArrayValidator = (validations: ValidationDefinition[]) => {
            return array().of(
                object().shape({
                    id: number(),
                    name: number(),
                    value: validations.reduce((validator, { type, params }) => {
                        // TODO: Find a way how to type properly StringSchema
                        // @ts-ignore
                        return validator[type](...params);
                    }, string()),
                })
            );
        };

        const mapRules = (definitions: SectionDefinition<SectionDefinitionValue>[]) => {
            return definitions.reduce((definitions, definition) => {
                switch (definition.type) {
                    case "String": {
                        if (Array.isArray(definition.value)) {
                            return {
                                ...definitions,
                                [`${definition.name}_Array`]: createStringArrayValidator(definition.validations),
                            };
                        }

                        return {
                            ...definitions,
                            [definition.name]: createStringValidator(definition.validations),
                        };
                    }

                    case "Number": {
                        return {
                            ...definitions,
                            [definition.name]: createNumberValidator(definition.validations),
                        };
                    }

                    case "DateTime":
                    case "Date": {
                        return {
                            ...definitions,
                            [definition.name]: createDateValidator(definition.validations),
                        };
                    }

                    default: {
                        return definitions;
                    }
                }
            }, {});
        };

        const createSchemaModel = (schema: FormSchema[]) => {
            return schema
                .reduce<SectionDefinition[]>((reducedField, field) => {
                    return [...reducedField, ...field.content];
                }, [])
                .filter((field) => field.editable);
        };

        return object(mapRules(createSchemaModel(schema)));
        // eslint-disable-next-line
    }, []);
};
